import type { ReactNode } from "react";

type FullPageErrorProps = {
  children: ReactNode;
  onCancel: VoidFunction;
};

export function FullPageError({ children, onCancel }: FullPageErrorProps) {
  return (
    <div className="fixed inset-0 z-50 flex h-screen w-screen flex-col items-center justify-center gap-4 bg-bg-tertiary/70">
      <svg
        fill="none"
        height="66"
        viewBox="0 0 66 66"
        width="66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.3">
          <rect
            height="49.4286"
            rx="23"
            stroke="#D92D20"
            strokeWidth="2"
            width="49.4286"
            x="8.28564"
            y="8.28516"
          />
        </g>
        <g opacity="0.1">
          <rect
            height="63.7143"
            rx="31.8571"
            stroke="#D92D20"
            strokeWidth="2"
            width="63.7143"
            x="1.14307"
            y="1.14453"
          />
        </g>
        <path
          d="M33.0002 26.332V32.9987M33.0002 39.6654H33.0168M49.6668 32.9987C49.6668 42.2034 42.2049 49.6654 33.0002 49.6654C23.7954 49.6654 16.3335 42.2034 16.3335 32.9987C16.3335 23.794 23.7954 16.332 33.0002 16.332C42.2049 16.332 49.6668 23.794 49.6668 32.9987Z"
          stroke="#D92D20"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>

      {children}
      <span
        className="text-sm font-semibold text-button-tertiary-color-fg cursor-pointer"
        onClick={onCancel}
      >
        Cancel
      </span>
    </div>
  );
}
